import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import '../../css/subPages.css';

import Header from "./Header";
import StartToday from "./StartToday";
import Footer from "../../components/Footer";

export default function WhyYouNeedDenise() {
    return (
        <>
            <Header pageSectionId="informationSection" />
            <Container className="subPageContainer">
                <Row className="pt-3 mb-3">
                    <Col sm={12} className="text-center">
                        <div className="subPageHeadingContainer">
                            <h3 className="subPageHeadingText">
                                WHY DO YOU NEED DENISE, A LICENSED MORTGAGE LOAN ORIGINATOR AND CERTIFIED DIVORCE LENDING PROFESSIONAL (CDLP&#174;)
                                ON YOUR TEAM?
                            </h3>
                        </div>
                    </Col>
                </Row>
                <Row className="pt-3 mb-3">
                    <Col sm={12} className="mb-3">
                        <h5 className="subPageText">
                            A Certified Divorce Lending Professional (CDLP&#174;) coupled with a
                            licensed mortgage loan officer, understands the connection between divorce,
                            family law, and mortgage financing. A CDLP&#174; brings in financial
                            knowledge and expertise, and provides you with the following benefits:
                        </h5>
                    </Col>
                    <Col className="mb-3">
                        <ul className="listItems">
                            <li className="mb-3">
                                <h5 className="subPageListItems">
                                    Assists the attorney and financial planner to understand the
                                    opportunities available, as well as the challenges a divorce can
                                    cause to mortgage financing during and after the divorce.
                                </h5>
                            </li>
                            <li className="mb-3">
                                <h5 className="subPageListItems">
                                    Recommends suitable financial strategies allowing divorcing clients
                                    to obtain mortgages to maintain the current marital home, as well as
                                    for departing spouses to obtain future mortgage financing.
                                </h5>
                            </li>
                            <li className="mb-3">
                                <h5 className="subPageListItems">
                                    Identifies potential concerns with support/maintenance structures that
                                    conflict with mortgage financing.
                                </h5>
                            </li>
                            <li className="mb-3">
                                <h5 className="subPageListItems">
                                    Works with divorcing couples and the professional divorce team in a
                                    collaborative setting and other alternative dispute resolution methods.
                                </h5>
                            </li>
                            <li className="mb-3">
                                <h5 className="subPageText">
                                    Helps you implement a strategic divorce settlement agreement in a manner that will
                                    facilitate opportunities for you to secure a mortgage post the divorce decree.
                                </h5>
                            </li>
                            <li className="mb-3">
                                <h5 className="subPageListItems">
                                    Provides expert mortgage solutions based on her knowledge of mortgage guidelines
                                    pertaining to divorcing clients.
                                </h5>
                            </li>
                            <li className="mb-3">
                                <h5 className="subPageListItems">
                                    Is committed to delivering high levels of Customer Service.
                                </h5>
                            </li>
                        </ul>
                    </Col>
                </Row>
                <StartToday />
            </Container>
            <Footer />
        </>
    );
}